import { render, staticRenderFns } from "./OperaComprehensiveServerWindow.vue?vue&type=template&id=78a5e55b&scoped=true&"
import script from "./OperaComprehensiveServerWindow.vue?vue&type=script&lang=js&"
export * from "./OperaComprehensiveServerWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaComprehensiveServerWindow.vue?vue&type=style&index=0&id=78a5e55b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5e55b",
  null
  
)

export default component.exports